/**
 * Created by Shuhin on 22 July 2020.
 */
import React from 'react';
import Dialog from 'material-ui/Dialog';
import Checkbox from 'material-ui/Checkbox';
import FlatButton from 'material-ui/FlatButton';
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";

const style = {
    checkbox: {
        marginTop: 20,
        marginRight: 5,
        marginLeft: "15px"
      },
      roleRadios: {
        marginLeft: "15px",
        display: "inline-block",
      },
      roleText: {
        float: "left",
        marginTop: "12px",
        fontSize: "15px",
        marginLeft: "15px",
        display: "inline-block",
      },
      buttonGroup: {
        paddingTop: "30px",
        paddingBottom: "15px",
        marginLeft: "40%",
      },
      roleFields: {
        height: "30px",
        width: "50%",
        marginTop: "10px",
        display: "inline-block",
      }
}

const UpdateRoleDialog = ({open, admin, super_admin, onCheck, onUpdate, toggleRoleDialog, handleSelect, role}) => {
 
  const actions = [
    <FlatButton
      label="Update"
      primary={true}
      keyboardFocused={true}
      onTouchTap={onUpdate} />,
    <FlatButton
      label="Cancel"
      onTouchTap={toggleRoleDialog} />
  ];

  return (
    <div>
      <Dialog
        open={open}
        modal={false}
        actions={actions}
        title="Update User Role"
        onRequestClose={toggleRoleDialog.bind(null, false, '')} >
        <RadioButtonGroup
          name="role"
          required={true}
          valueSelected={role}
          style={style.roleRadios}
          onChange={handleSelect.bind(null, 'role')}
        >
          <RadioButton
            value="admin"
            label="admin"
            style={style.roleFields}
          />
          <RadioButton
            value="scheduler"
            label="scheduler"
            style={style.roleFields}
          />
          <RadioButton
            value="rmg"
            label="RMG"
            style={style.roleFields}
          />
        </RadioButtonGroup>
        {
          admin && 
          <Checkbox
            label="Super admin"
            style={style.checkbox}
            checked={super_admin}
            onCheck={onCheck.bind(null, 'super_admin')}
          />
        }
      </Dialog>
    </div>
  );
};

export default UpdateRoleDialog;


// WEBPACK FOOTER //
// ./src/screens/profile/admin/update-role.js